export default __webpack_public_path__ + "static/media/06AW1APR66.347e14e8.jpg";